import { Link } from "react-router-dom";

export default function DiscountBannerSection() {
  return (
    <section className="relative overflow-hidden h-80 md:h-100 lg:h-110 flex items-center normal-case tracking-normal select-none md:px-16">
      <div className="absolute inset-0 z-0">
        <img alt="Special Offer Background" loading="lazy" className="w-full h-full object-cover" src="/images/discount_banner.jpeg" />
        <div className="absolute inset-0 bg-linear-to-r from-[#2B0B14]/95 via-[#2B0B14]/70 to-transparent z-10"></div>
        <div className="absolute inset-0 bg-[#1A0E06]/25 z-10"></div>
      </div>

      <div className="container relative z-20 px-6 mx-auto max-w-350">
        <div className="max-w-2xl space-y-4 md:space-y-6 text-left">
          <div className="space-y-2">
            <p className="text-[11px] md:text-xs font-semibold text-secondary tracking-[0.3em] uppercase">Limited Time Offer</p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white font-normal leading-tight tracking-tight uppercase">
              Flat 15% OFF <br className="hidden md:block" />
              <span className="text-secondary drop-shadow-[0_2px_10px_rgba(242,160,7,0.3)]">On All Products</span>
            </h2>
          </div>
          <p className="text-sm md:text-base text-white/75 leading-relaxed font-body max-w-lg normal-case">Premium quality gemstones &amp; jewellery at exclusive prices.</p>
          <div className="pt-2">
            <Link
              to="/products"
              className="inline-flex items-center justify-center whitespace-nowrap bg-secondary text-white font-bold py-2 px-8 h-11 rounded-full text-[11px] tracking-widest uppercase transition-all duration-300 border-none shadow-lg shadow-secondary/20 hover:bg-white hover:text-[#2B0B14] active:scale-95 cursor-pointer"
              style={{ textShadow: '0 1px 2px rgba(60,16,8,0.45)' }}
            >
              Order Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
